import PasswordBlock from '@anm/components/form/PasswordBlock';
import { DisplayNameField, EmailField } from '@anm/components/form/fields';
import {
  composeValidators,
  displayName,
  mailWithCheckExistValidator,
  maxLength,
  required
} from '@anm/components/form/validators';
import { Omit } from 'helpers';
import { FC } from 'react';

import { submitFormFields, submitFormValidators, FieldsParams, SubmitForm, SubmitFormProps } from '../../SubmitForm';

type SignUpFormProps = Omit<SubmitFormProps, 'validators' | 'renderFields'>;
const { ReCaptchaField } = submitFormFields;
const renderSignUpFields = (props: FieldsParams) => (
  <>
    <EmailField />
    <DisplayNameField validate={composeValidators(required(), displayName, maxLength(60))} />
    <PasswordBlock {...props} />
    <ReCaptchaField />
  </>
);

const { captchaValidator } = submitFormValidators;
const SignUpValidators = {
  email: mailWithCheckExistValidator(),
  captcha: captchaValidator
};

const SignUpForm: FC<SignUpFormProps> = props => (
  <SubmitForm validators={SignUpValidators as any} renderFields={renderSignUpFields} {...props} />
);

export default SignUpForm;
